import type { ChatReaction } from './types/domain';

export const LIMITS = {
  displayNameMax: 32,
  roomNameMax: 60,
  chatMessageMax: 1000,
  chatHistory: 200,
  /** Max characters (code points) of the quoted original stored in a reply. */
  chatReplySnippetMax: 120,
  urlMax: 2048,
  /** Full mesh WebRTC degrades quickly beyond this. */
  maxParticipantsHard: 8,
  minParticipants: 2,
  signalPayloadMaxBytes: 16 * 1024,
} as const;

export const CHAT_REACTIONS: readonly ChatReaction[] = ['❤️', '😂', '😮', '😢', '🔥', '👍'];

/** Quick reactions floating over the player. */
export const STAGE_REACTIONS = ['❤️', '😂', '😮', '🔥', '👏'] as const;
export type StageReaction = (typeof STAGE_REACTIONS)[number];
